export default {"src":"/_next/static/image/public/images/ic_doctor_bg.82b7c6bba3ebc1f9b599a902076412c2.svg","height":76,"width":76};